"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipTapContentSchema = void 0;
const zod_1 = require("zod");
const tip_tap_1 = require("../tip-tap");
exports.TipTapContentSchema = zod_1.z
    .custom()
    .superRefine((value, ctx) => {
    try {
        (0, tip_tap_1.validateJSONContent)(value);
    }
    catch {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Invalid TipTap JSON content: ${JSON.stringify(value)}`,
            fatal: true,
        });
        return zod_1.z.NEVER;
    }
})
    .optional();
//# sourceMappingURL=tiptap-content.schema.js.map